import Head from "next/head";

import GetGrowthCases from "components/sections/GetGrowthCases";

const GrowthCases = () => {
  return (
    <div className="wrapper">
      <Head>
        <title>5 App Growth Cases for Subscription Apps - Apphud Guide</title>
        <meta
          name="title"
          content="5 App Growth Cases for Subscription Apps - Apphud Guide"
        />
        <meta
          name="description"
          content="This white paper examines five distinct growth cases that subscription apps can leverage to remain competitive in the mobile market. Sign up for Apphud today!"
        />
        <meta
          property="keywords"
          content="app growth, subscription app growth"
        />
        <meta
          property="og:title"
          content="5 App Growth Cases for Subscription Apps - Apphud Guide"
        />
        <meta
          property="og:description"
          content="This white paper examines five distinct growth cases that subscription apps can leverage to remain competitive in the mobile market. Sign up for Apphud today!"
        />
      </Head>
      <GetGrowthCases />
    </div>
  );
};

export default GrowthCases;
